import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
import { AddPageHeader } from "../Common/Utils";

const showResume = (el) => {
  return (
    <div>
      <h3>{el.surname + ", " + el.firstname}</h3>
      {el["surname-first-name-translation"] && (
        <div>{el["surname-first-name-translation"]}</div>
      )}
      <br />
      <div
        style={{
          textDecoration: "underline",
          color: "black",
        }}
      >
        Main affiliation(s)
      </div>
      <ul
        style={{
          display: "inline-list-item",
          listStyle: "square",
          listStylePosition: "inside",
          paddingInlineStart: "0px",
        }}
      >
        <li>{el["affiliation-1"]}</li>
        <li>{el["affiliation-2"]}</li>
        <li>{el["affiliation-3"]}</li>
      </ul>
      {el.role}
    </div>
  );
};

const Contributors = () => {
  const [contributors, setContributors] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getContributors().then((data) => setContributors(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Contributors")}
      <Divider align="center">
        <h1>Contributors</h1>
      </Divider>
      <div className="privacy-terms">
        <p>This page features several contributors, past and present.</p>
      </div>
      <div className="grid">
        {contributors.map((el) => (
          <div key={el.surname} className="col-12 md:col-4 flex">
            <Card className="flex flex-column justify-content-between w-full">
              <div className="grid">
                <div className="flex justify-content-center flex-wrap col-12">
                  <img
                    className="flex align-items-center"
                    src={"visuals/" + el.visual}
                    alt=""
                    width="150em"
                  />
                </div>
                <div
                  className="flex align-items-center col-12"
                  style={{ textAlign: "left" }}
                >
                  {showResume(el)}
                </div>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contributors;
